import { useState } from 'react';

import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import { Link } from "react-router-dom";
import MLink from '@mui/material/Link';

import ModalDialogue from './ModalDialogue';

import ContextMenu from './ContextMenu.js';

import {
    RemoveCircle as RemoveCircleIcon
} from '@mui/icons-material';

import { Button, Box } from '@mui/material';

export default function CountryListSingle(props) {
    const [deleteModal, setDeleteModal] = useState(false);

    const toggleDeleteModal = event => {
        setDeleteModal(!deleteModal);
    }

    var options = [];

    if( props.onDelete )
    {
        options.push({icon: <RemoveCircleIcon />, label: 'Delete Country', onClick: toggleDeleteModal});
    }

    return (
        <TableRow key={props.data.getId()} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
            <TableCell sx={{width: '45%', paddingRight: 0}} component="th" scope="row">
                <Typography variant="body1">
                    <MLink component={Link} to={`/countries/${props.data.getId()}/edit`}>{props.data.getName()}</MLink>
                </Typography>
            </TableCell>
            <TableCell sx={{width: '45%', paddingRight: 0}}>
                <Typography variant="subtitle2">{props.data.getRegion() ? props.data.getRegion().getName() : null}</Typography>
            </TableCell>
            <TableCell sx={{width: '10%', paddingRight: 0}}>
                <ModalDialogue showFooter={false} open={deleteModal} onClose={toggleDeleteModal}>
                    <Box sx={{px: 2, pt: 2, pb: 1}}>

                        <Typography mb={2} variant="h4">Delete Country</Typography>
                        <Typography variant="body1">Are you sure you want to delete {props.data.getName()}?.</Typography>

                        <Box sx={{textAlign: 'right'}}>
                            <Button
                                onClick={toggleDeleteModal}
                                sx={{mt: 2, ml: 2}}
                            >
                                Cancel
                            </Button>

                            <Button
                                onClick={() => {
                                    if( props.onDelete )
                                    {
                                        props.onDelete(props.data.getId()).then(deleteResponse => {
                                            toggleDeleteModal();
                                        });
                                    }
                                }}
                                sx={{mt: 2, ml: 2}
                            }>
                                Delete
                            </Button>
                        </Box>
   
                    </Box>
                </ModalDialogue>
                {
                    options &&
                        <ContextMenu
                            options={options}
                        />
                }
            </TableCell>
        </TableRow>
    );
}
